

<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="createNew()">Upload New Version</button>
</div>
<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
</ngx-spinner>

<ngx-datatable #packageTable
               class='material striped datatable'
               [rows]='stationApps'
               [columnMode]='"force"'               
               [headerHeight]='40'
               [footerHeight]='20'
               [scrollbarH]="true"
               [scrollbarV]="true"
               [rowHeight]="40"
               [messages]='{emptyMessage:"No apps to display here!"}'
               [reorderable]="true">

    <ngx-datatable-column prop="version" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Version
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.version}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="name" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Date Created
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.dateCreated | date: 'MM-dd-yyyy'}} 
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="current" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Currently Deployed 
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.current ? '✓' : ''}} 
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="forceUpdate" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Force Update 
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.forceUpdate ? '✓' : ''}} 
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="fileUrl" [width]="200" [minWidth]="200" [maxWidth]="600" >
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                File URL
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template >
            <a *ngIf="!copied[rowIndex + '-fileUrl']" (click)="copy(row.fileUrl, rowIndex)"  href='#' style="padding-right: 8px"> <i class="m-menu__link-icon flaticon-clipboard"></i></a>
            <a *ngIf="copied[rowIndex + '-fileUrl']" (click)="copy(row.fileUrl, rowIndex)"  href='#' style="padding-right: 8px"> <i class="m-menu__link-icon flaticon-close"></i></a>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column  [sortable]="false" [minWidth]="200" [maxWidth]="200">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template prop="actions" let-row="row" ngx-datatable-cell-template >
            <button style="float: right;" [debounceClick] *ngIf="!row.forceUpdate" class="btn btn-info btn-icon" (click)="confirmForceUpdate(row.posStationAppId)"><i class="flaticon-exclamation-2"></i></button>
            <button style="float: right;" [debounceClick] *ngIf="!row.current" class="btn btn-warning btn-icon" (click)="confirmSetCurrent(row.posStationAppId)"><i class="flaticon-warning-2"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>





